// extracted by mini-css-extract-plugin
module.exports = {"user":"PageHeaderUser_user_LeQLi","name":"PageHeaderUser_name_1PmQQ","image":"PageHeaderUser_image_h2AKY"};